import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Activity16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.2296 3.3263L8.05587 10.9966L9.77736 4.79928C9.95717 4.15195 10.8704 4.06369 11.1708 4.6646L12.8944 8.11182C12.9368 8.19651 13.0233 8.25001 13.118 8.25001H16V9.75001H13.118C12.4552 9.75001 11.8492 9.37551 11.5528 8.78264L10.7009 7.07891L8.72264 14.2007C8.52034 14.929 7.44547 14.909 7.2704 14.1737L5.34987 6.10751L4.44421 8.59806C4.19273 9.28964 3.53546 9.75001 2.79957 9.75001H0V8.25001H2.79957C2.9047 8.25001 2.99859 8.18425 3.03452 8.08545L4.79516 3.24371C5.0435 2.56076 6.06129 2.61936 6.2296 3.3263Z'
      fill='currentColor'
    />
  </Svg>
);

Activity16.displayName = 'Activity16';
export default Activity16;
